import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowDropdown } from 'react-icons/io';

const TotalAccountsMobile = () => {
    const [isExpanded, setExpanded] = useState(false);
    const toggleExpand = () => {
        setExpanded(!isExpanded);
    };
    return (
    <Link to='/profile/totalAccounts' className='flex flex-col rounded-lg bg-white shadow-sm w-[95%] py-2 px-2'>
        <div className='flex flex-row justify-around items-center my-2'>
            <div className='flex flex-col gap-2'>
                <p className='text-primary text-lg'>Total Accounts</p>
                <div className='flex flex-row justify-around items-center gap-2'>
                    <p className='text-[10px] text-black font-semibold'>11 Accounts</p>
                    <p className='text-[9px] text-green-500 font-semibold'>10 Active</p>
                    <p className='text-[9px] text-red-500 font-semibold'>00 Closed</p>
                </div>
            </div>
            <div className='flex flex-col gap-1'>
                <p className='text-lg text-black font-semibold'>₹ 41,83,126</p>
                <p className='text-xs text-gray-500'>Total OutStanding</p>
            </div>
        </div>
        {/* {!isExpanded ? 
            <div className='flex flex-row justify-end items-center mr-6'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 px-2 text-primary text-xs">View More <IoIosArrowDropdown className='ml-1'/></button>
            </div> :
            <div className='flex flex-row justify-end items-center mr-6'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 px-2 text-primary text-xs">View Less <IoIosArrowDropup className='ml-1'/></button>
            </div>
        } */}
        <div className='flex flex-row justify-end items-center mr-6'>
            <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 px-2 text-primary text-xs">View More <IoIosArrowDropdown className='ml-1'/></button>
        </div>
    </Link>
    )
}

export default TotalAccountsMobile